import { createActions, createReducer } from 'reduxsauce'

import ExerciciosReceitaArrecadadaService from '../servicos/ExerciciosReceitaArrecadaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaExerciciosReceitaArrecadadaInicio: [],
    buscaExerciciosReceitaArrecadadaSucesso: ['exercicios', 'jaSelecionado'],
    buscaExerciciosReceitaArrecadadaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaExerciciosReceitaArrecadada = jaSelecionado => {
    return dispatch => {
        dispatch(Creators.buscaExerciciosReceitaArrecadadaInicio())
        let serv = new ExerciciosReceitaArrecadadaService()
        return serv
            .getExercicios()
            .then(response => dispatch(Creators.buscaExerciciosReceitaArrecadadaSucesso(response.data, jaSelecionado)))
            .catch(error => dispatch(Creators.buscaExerciciosReceitaArrecadadaErro(error)))
    }
}

const buscaExerciciosReceitaArrecadadaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaExerciciosReceitaArrecadadaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaExerciciosReceitaArrecadadaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.exercicios, carregando: false, selecionado: action.jaSelecionado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EXERCICIOS_RECEITA_ARRECADADA_INICIO]: buscaExerciciosReceitaArrecadadaInicio,
    [Types.BUSCA_EXERCICIOS_RECEITA_ARRECADADA_ERRO]: buscaExerciciosReceitaArrecadadaErro,
    [Types.BUSCA_EXERCICIOS_RECEITA_ARRECADADA_SUCESSO]: buscaExerciciosReceitaArrecadadaSucesso,
})
